import * as React from "react";
import Box from "@mui/material/Box";
// import axios from "axios";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";

import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Popup from "reactjs-popup";
import { Button } from "@mui/material";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  ></Box>
);

const Enquiry = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = React.useState(1);
  const superuserId = localStorage.getItem("is_superuser");
  const storeId = localStorage.getItem("store_id");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [descritpion, setDescription] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [vendorData, setVendorData] = useState([]);

  const enquiryDataList = () => {
    superuserId == "true"
      ? axiosInstance
          .post(
            `api/admin/multivendor-inquery-list-api/`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            setData(response?.data?.inquiry_section_data);
            console.log(
              "enquiry data list==>",
              response?.data?.inquiry_section_data,
            );
          })
          .catch((error) => {
            console.log("", error.response);
            console.log(error);
            toast.error(error.message);
          })
      : axiosInstance
          .post(
            `api/admin/multivendor-inquery-list-api/`,
            { store_id: storeId },
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            setData(response?.data?.inquiry_section_data);
            console.log(
              "enquiry data list==>",
              response?.data?.inquiry_section_data,
            );
          })
          .catch((error) => {
            console.log("", error.response);
            console.log(error);
            toast.error(error.message);
          });
  };

  useEffect(() => {
    enquiryDataList();
  }, []);

  const dataSubmit = (e, id) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("inquiry_id", id);
    fd.append("ticket_closed_remark", descritpion);
    axiosInstance
      .post(`api/admin/multivendor-close-inquery-admin/`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response?.data?.message);
        enquiryDataList();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  const vendorDataList = () => {
    axiosInstance
      .post(
        `api/admin/multivendor-vendor-list-data/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setVendorData(response?.data?.vendor_list_data);
        console.log("vendor data list ====>", response?.data?.vendor_list_data);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };
  useEffect(() => {
    vendorDataList();
  }, []);

  const assignData = (event, row) => {
    event.preventDefault();
    const fd = new FormData();
    fd.append("ticket_id", row);
    fd.append("vendor_email", vendorName);
    axiosInstance
      .post(`api/multivendor-customer-raise-question-list/`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response?.data?.mssage);
        enquiryDataList();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };
  console.log(open2);
  return (
    <>
      <div className="!bg-white">
        <div className="flex justify-between !bg-slate-100">
          <div className="p-2">
            <p className="text-xl font-bold !text-black">
              Enquiry Management List
            </p>
          </div>
          <div className="p-2">
            <div className="flex items-center p-2 !bg-slate-100 border-zinc-600">
              {/* <input
                type="text"
                className="!border-3 !border-black px-2 !w-64 rounded-md py-1"
                placeholder="search"
                style={{ border: "1px solid black" }}
              /> */}
            </div>
          </div>
        </div>
        <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
          <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-24">TICKET ID </div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    CUSTOMER EMAIL
                  </TableCell>
                  {/* <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    VENDOR EMAIL
                  </TableCell> */}

                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    IMAGE
                  </TableCell>

                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-24">TITLE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-32">ENQUIRY TYPE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-72">DECRIPTION</div>
                  </TableCell>

                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-64">REMARKED</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-28">CREATE DATE</div>
                  </TableCell>
                  {superuserId === "true" ? (
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center  !text-gray-800 !font-bold"
                    >
                      <div className="w-28">RESOLVE DATE</div>
                    </TableCell>
                  ) : null}
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-24">STATUS</div>
                  </TableCell>
                  {superuserId === "true" ? null : (
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center  !text-gray-800 !font-bold"
                    >
                      REMARKED
                    </TableCell>
                  )}
                  {superuserId === "true" ? (
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center  !text-gray-800 !font-bold"
                    >
                      <div className="w-32">Assign To Vendor</div>
                    </TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map((row) => (
                    <TableRow
                      key={row?.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.ticket_id ? row?.ticket_id : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.customer_email ? row?.customer_email : "--"}
                      </TableCell>
                      {/* <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.assignee_vendor ? row?.assignee_vendor : "--"}
                      </TableCell> */}

                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.images ? (
                          <Popup
                            trigger={
                              <img
                                src={row?.images}
                                className="h-8 w-8 mx-auto"
                                onClick={handleOpen2}
                              />
                            }
                            modal
                          >
                            <div className="bg-white p-5 border shadow-sm shadow-indigo-900 rounded-lg text-black">
                              <div className="">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { width: "70ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <div className="py-3 mx-auto text-center underline underline-offset-2">
                                    Enguiry Image{" "}
                                  </div>
                                  <div>
                                    <img
                                      src={row?.images}
                                      className="!w-full"
                                    />
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </Popup>
                        ) : (
                          "--"
                        )}
                      </TableCell>

                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.title ? row?.title : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.inquiry_type ? row?.inquiry_type : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.description ? row?.description : "--"}
                      </TableCell>

                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.ticket_closed_remark
                          ? row?.ticket_closed_remark
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.created_at ? row?.created_at.slice(0, 10) : "--"}
                      </TableCell>
                      {superuserId === "true" ? (
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.resolved_date
                            ? row?.resolved_date.slice(0, 10)
                            : "--"}
                        </TableCell>
                      ) : null}
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.status ? row?.status : "--"}
                      </TableCell>
                      {row?.status === "closed" ? (
                        <TableCell
                          style={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                          className="!text-center  !text-gray-800 !font-bold"
                        >
                          <Button
                            className="!bg-red-500 !text-white !text-[12px]"
                            size="small"
                          >
                            REMARKED
                          </Button>
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                          className="!text-center  !text-gray-800 !font-bold"
                        >
                          <div className="mx-auto ">
                            <Popup
                              trigger={
                                <button
                                  className="bg-green-500 text-white p-1 px-3 rounded"
                                  onClick={handleOpen}
                                >
                                  REPLY
                                </button>
                              }
                              modal
                            >
                              <div className="bg-white p-5 border shadow-sm shadow-indigo-900 rounded-lg text-black">
                                <div className="">
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": { width: "40ch" },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <div className="pt-3 mx-auto text-center underline underline-offset-2">
                                      Assigned Inquiry{" "}
                                    </div>
                                    <div className="pt-3">Remarks : </div>
                                    {/*  */}
                                    <textarea
                                      className="border p-2 rounded border-gray-500"
                                      placeholder="Write Remark..."
                                      rows={"4"}
                                      onChange={(event) =>
                                        setDescription(event.target.value)
                                      }
                                    ></textarea>
                                    <br />
                                    <button
                                      onClick={(e) => dataSubmit(e, row.id)}
                                      className="bg-success py-1 rounded-lg text-white mt-1"
                                    >
                                      submit
                                    </button>
                                  </Box>
                                </div>
                              </div>
                            </Popup>
                          </div>
                        </TableCell>
                      )}
                      {superuserId === "true" ? (
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.is_assigned_to_vendor ? (
                            <Button
                              size="small"
                              className="!bg-red-500 !text-white !text-[12px]"
                            >
                              ASSIGNED
                            </Button>
                          ) : (
                            <Popup
                              trigger={
                                <button
                                  className="bg-green-500 text-white p-1 px-3 rounded"
                                  onClick={handleOpen1}
                                >
                                  ASSIGN
                                </button>
                              }
                              modal
                            >
                              <div className="bg-white p-5 border shadow-sm shadow-indigo-900 rounded-lg text-black">
                                <div className="">
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": { width: "40ch" },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <div className="py-3 mx-auto text-center underline underline-offset-2">
                                      Assigned To Vendor{" "}
                                    </div>
                                    <label for="browser">Choose Vendor:</label>
                                    <br />
                                    <input
                                      className="border border-gray-600 !w-72 rounded py-1 px-2 m-1"
                                      list="browsers"
                                      name="browser"
                                      id="browser"
                                      onChange={(event) =>
                                        setVendorName(event.target.value)
                                      }
                                    />

                                    <datalist id="browsers">
                                      {vendorData?.map((item) => (
                                        <option value={item?.email}>
                                          {item?.store_name}
                                        </option>
                                      ))}
                                    </datalist>
                                    <button
                                      className="bg-success !w-20 py-1 font-bold rounded-lg m-1 text-white mt-1"
                                      onClick={(event) =>
                                        assignData(event, row?.ticket_id)
                                      }
                                    >
                                      APPLY
                                    </button>
                                  </Box>
                                </div>
                              </div>
                            </Popup>
                          )}
                        </TableCell>
                      ) : null}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default Enquiry;
